import React from 'react';

import { di } from 'react-magnetic-di';

import { FormRenderMode } from '../../../../../../../common/types/render-mode';
import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import { useFormRenderMode } from '../../../../../../../controllers/form-renderer-store';
import { EditDateInput } from './edit';
import { PreviewDateInput } from './preview';
import { ViewDateInput } from './view';

export const DateInput = ({
	fieldId,
	fieldInputId,
	fieldLabelId,
	fieldErrorId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormRenderMode);
	const renderMode = useFormRenderMode();

	switch (renderMode) {
		case FormRenderMode.EDIT:
			return (
				<EditDateInput
					fieldId={fieldId}
					fieldInputId={fieldInputId}
					fieldLabelId={fieldLabelId}
					fieldErrorId={fieldErrorId}
				/>
			);
		case FormRenderMode.PREVIEW:
			return (
				<PreviewDateInput
					fieldId={fieldId}
					fieldInputId={fieldInputId}
					fieldLabelId={fieldLabelId}
					fieldErrorId={fieldErrorId}
				/>
			);
		default:
			return (
				<ViewDateInput
					fieldId={fieldId}
					fieldInputId={fieldInputId}
					fieldLabelId={fieldLabelId}
					fieldErrorId={fieldErrorId}
				/>
			);
	}
};
